import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { AssistantIcon } from '../../assets/AssistantIcon';

const TITLE = 'Need help?';

export const CompactHeader = () => {
  return (
    <div
      id="ai-assisted-search-banner-header"
      data-testid="ai-assisted-search-banner-header"
      className="sui-flex sui-items-center sui-gap-3"
    >
      <AssistantIcon color="brand" height={28} width={24} />
      <Typography
        id="ai-assisted-search-banner-title"
        component="h2"
        variant="h5"
        weight="bold"
        color="primary"
      >
        {TITLE}
      </Typography>
    </div>
  );
};

CompactHeader.displayName = 'CompactHeader';
